import { ChargingSpeedType, ConnectorStatuses, ConnectorType } from "@/@types";
import { ConnectorEntity } from "@/domain/entities";

export class Connector {
  id: string;
  connector_id: string;
  charger_id: string;
  location_title: string = "";
  status: string;
  status_config: {
    color: string;
    label: string;
  };
  type: string;
  plan: string = "";
  speed_type: { value: ChargingSpeedType; label: string } | null = null;
  speed: string = "";
  qrcode?: {
    img: string;
    download: string;
  };

  constructor(connector: ConnectorEntity) {
    this.id = connector.id;
    this.connector_id = connector.connector_id || "";
    this.charger_id = connector.charger_id;
    this.status = connector.status;
    this.status_config = Connector.formatStatus(connector.status);
    this.type = Connector.types[connector.type as ConnectorType] || "";
    if (connector.pricing_profile) {
      this.plan = connector.pricing_profile?.title;
    }

    if (connector.max_charging_speed) {
      this.speed = String(connector.max_charging_speed);
    }

    if (connector.charging_speed_type) {
      this.speed_type = Connector.speed_types[connector.charging_speed_type];
    }

    if (connector.charger && connector.charger.location) {
      this.location_title = connector.charger?.location?.title;
    }

    const baseUrl: string = `${process.env.VUE_APP_API_URL.replace(
      "api/",
      ""
    )}`;

    this.qrcode = {
      img: `${baseUrl}connector-qrcode/${connector.id}`,
      download: `${baseUrl}connector-qrcode/${connector.id}?mode=download`,
    };
  }

  static empty: Connector = {
    id: "",
    connector_id: "",
    charger_id: "",
    status: "",
    type: "",
    plan: "",
    speed: "",
    speed_type: {
      value: "slow",
      label: "",
    },
    status_config: {
      color: "",
      label: "",
    },
    location_title: "",
  };

  static types: Record<ConnectorType, string> = {
    type_1: "Type 1",
    type_2: "Type 2",
    ccs1: "CCS1",
    ccs2: "CCS2",
    chademo: "Chademo",
    gb_t: "GB T",
    tesla: "Tesla",
    nacs: "Nacs",
  };

  static speed_types: Record<
    ChargingSpeedType,
    { value: ChargingSpeedType; label: string }
  > = {
    slow: {
      value: "slow",
      label: "Carga normal",
    },
    fast: {
      value: "fast",
      label: "Carga rápida",
    },
    ultra: {
      value: "ultra",
      label: "Carga ultra rápida",
    },
  };

  static formatStatuses = (connectors: Pick<ConnectorEntity, "status">[]) => {
    let statuses = [];

    for (const connector of connectors) {
      if (ConnectorStatuses.muted.includes(connector.status))
        statuses.push("muted");
      if (ConnectorStatuses.danger.includes(connector.status))
        statuses.push("danger");
      if (ConnectorStatuses.success.includes(connector.status))
        statuses.push("success");
    }

    return statuses;
  };

  static formatStatus = (connectorStatus: string) => {
    let status = {
      color: "",
      label: "",
    };

    if (ConnectorStatuses.muted.includes(connectorStatus)) {
      status.color = "muted";
      status.label = "Indisponível";
    }
    if (ConnectorStatuses.danger.includes(connectorStatus)) {
      status.color = "danger";
      status.label = "Em uso";
    }
    if (ConnectorStatuses.success.includes(connectorStatus)) {
      status.color = "success";
      status.label = "Disponível";
    }

    return status;
  };
}
